<div class="rich-notes-wrapper">
  <i class="icon__notifications {{getNotesClass()}}" (click)="openNotesDialog();"></i>
</div>
